/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CalendarCheckedOutIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CalendarCheckedOutIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CalendarCheckedOutIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CalendarCheckedOutIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 10"
 style={{'--as-1-ZJwvwI': alignSelf,'--mt-2-ZJwvwI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZJwvwI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZJwvwI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZJwvwI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZJwvwI': opacity,'--w-10-ZJwvwI': typeof width === 'number' ? `${width}px` : width,'--h-11-ZJwvwI': typeof height === 'number' ? `${height}px` : height,'--f-12-ZJwvwI': fill,'--a-7-ZJwvwI': isAnimated ? animation : "none",'--sd-8-ZJwvwI': isAnimated ? strokeDashoffset : 0,'--sd-9-ZJwvwI': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CalendarCheckedOutIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 1.071C0 .48.48 0 1.071 0h5c.592 0 1.072.48 1.072 1.071v1.385a1.43 1.43 0 00-.525.937h-2.51a1.607 1.607 0 100 3.214h2.51c.047.371.237.707.525.937v1.385C7.143 9.52 6.663 10 6.07 10h-5C.48 10 0 9.52 0 8.929V1.07zm7.83 2.006a.536.536 0 00-.33.494v.715H4.107a.714.714 0 100 1.428H7.5v.715a.536.536 0 00.915.378L9.843 5.38a.536.536 0 000-.758L8.415 3.193a.536.536 0 00-.584-.116z"
 style={{'--f-12-ZJwvwI': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}